<template>
  <div id="capture-image-modal" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <a data-dismiss="modal" href="javascript:;">
          <XIcon class="w-8 h-8 text-gray-500" />
        </a>
        <div class="modal-body p-10">
          <!-- <div id="vertical-form"> -->
          <div class="flex flex-col justify-between mt-5">
            <!-- BEGIN: Data List -->
            <div class="intro-y overflow-auto">
              <div class="flex items-center">
                <h2 class="intro-y text-lg font-medium mr-5">Upload Image</h2>
              </div>
            </div>
            <div class="grid grid-cols-12 gap-4">
              <div class="intro-y col-span-12">
                <!-- BEGIN: Dropzone -->
                <CameraCapture ref="CameraCaptureRef" @onCaptured="onCaptured" />

                <div ref="dropzone" id="uploadZone" class="dropzone mt-4"></div>
                <!-- END: Dropzone -->
              </div>
            </div>
            <!-- END: Data List -->
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import Dropzone from 'dropzone'
import CameraCapture from '@/components/capture/CameraCapture.vue'
import { onMounted, reactive, ref } from 'vue'
import { BASE_URL } from '@/constants/config'

export default {
  components: {
    CameraCapture
  },

  emits: ['onCaptured'],

  setup(props, { emit, expose }) {

    const dropzone = ref(null)
    const CameraCaptureRef = ref(null)

    const page_data = reactive({
      base_url: BASE_URL,
      end_point: '',
    })

    onMounted(() => {
      Dropzone.autoDiscover = false

      dropzone.value = new Dropzone('#uploadZone', {
        url: `${page_data.base_url}api/plan/uploadImage`,
        method: 'post',

        maxFiles: 1,
        maxFilesize: 2,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        thumbnailWidth: 150,

        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },

        init() {
          this.on('addedfile', () => {
            if (this.files.length > 1) {
              this.removeFile(this.files[0])
            }
          })

          this.on('error', (file, message) => {
            this.removeFile(file)

            Swal.fire({
              icon: 'error',
              text: typeof message === 'string' ? message : 'Upload failed',
              confirmButtonText: 'Try again',
            })
          })

          this.on('success', (file, response) => {
            emit('onCaptured', {
              path: response.path,
              file_name: response.file_name,
            })

            cash('#capture-image-modal').modal('hide')
            CameraCaptureRef.value.stopCamera()

            Swal.fire({
              icon: 'success',
              title: 'Uploaded',
              text: 'Image uploaded successfully',
            })

            this.removeAllFiles(true)
          })
        },
      })
    })

    const apiOption = (end_point) => {
      cash('#capture-image-modal').modal('show')
      page_data.end_point = end_point
      CameraCaptureRef.value.startCamera()
    }

    const onCaptured = (blob) => {
      const file = new File(
        [blob],
        `camera_${Date.now()}.jpg`,
        { type: blob.type }
      )

      dropzone.value.addFile(file)
    }

    // ✅ Expose method to parent
    expose({
      apiOption
    })

    return {
      dropzone,
      CameraCaptureRef,
      page_data,
      onCaptured,
    }
  }
}
</script>
